import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// register() enables the app to work offline and load faster.
// Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// To undo this, change register() to unregister() below. 
serviceWorkerRegistration.register();
